import React from "react";
import Grid from "@mui/material/Grid2";
import CarePlanTab from "./CarePlanTab";
import Box from '@mui/material/Box';
import BookingTabPanel from './BookingTab';
import useDebugInformation from "../../../../../../hooks/useDebugInformation";
import TabPanel from "../../../../../Shared/TabPanel"
import ToggleButtonsGroup from "../../../../../Shared/ToggleButtonsGroup";
import RatesTab from "./RatesTab";
import FinalModal from "./FinalModal";
import { carePlanValidate } from "@utils/general";
import { useAppSelector } from "@store/hooks";
import { Typography } from '@mui/material';

const name = "StepThreeForm"

const getCareTab = (sa: string, debugName: string) => {
  return sa
    ? <TabPanel children={<>
      {/* <h3>{`Service Agreement REF: ${sa}`}</h3> */}
      <Typography variant="h5" fontWeight="bolder">Service Agreement REF: {sa}</Typography>
      <Typography variant="h6">The care plan reduced rate has been automatically applied to this booking.</Typography>
      <Typography color="red" variant="h6">To ensure clear communication with the customer, please review the charge rate script thoroughly and confirm the new rates are fully explained to customer!!</Typography>
    </>} value={0} index={0} parent={debugName} style={{ margin: "auto", border: "1px solid black", padding: "5px" }} />
    : <CarePlanTab parent={debugName} />
}

type Props = {
  parent: string
}

const StepThreeForm: React.FC<Props> = ({ parent }) => {
  const stepThreeActiveTab = useAppSelector(({ ui }) => ui.StepThreeActiveTab)
  const serviceAgreementReference = useAppSelector(({ ui }) => ui.CarePlanReference)
  const isBusiness = useAppSelector(({ ui }) => ui.PropertyAddressIsBusiness)
  const [values, setValues] = React.useState<any>([]);

  // react hook to check if combo job offers plan
  React.useEffect(() => {
    if (!isBusiness) {
      setValues(["charge rate", "care plan", "booking"])
    } else {
      setValues(["charge rate", "booking"])
      carePlanValidate()
    }
  }, [isBusiness])

  React.useEffect(() => {
    if (serviceAgreementReference) {
      carePlanValidate();
    }
  }, [serviceAgreementReference])

  const debugName = `${parent}▷[${name}]`

  useDebugInformation(debugName, { stepThreeActiveTab, serviceAgreementReference, isBusiness })
  return (
    < Box sx={{ '& input': { height: '1em' } }}>
      <ToggleButtonsGroup values={values} groupName="StepThreeActiveTab" step={3} />
      <FinalModal parent={debugName} />
      <Grid container >
        {stepThreeActiveTab === "charge rate" && <RatesTab parent={debugName} />}
        {stepThreeActiveTab === "care plan" && getCareTab(serviceAgreementReference, debugName)}
        {stepThreeActiveTab === "booking" && <BookingTabPanel parent={debugName} />}
      </Grid>
    </Box>
  );
}

export default StepThreeForm
